import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Supportph from "../../assets/pic/support.jpg";
import {Helmet} from "react-helmet";

const DemoEn = ()=>{
    return(
        <div className='demo-dec'>
            <Helmet>
                <title>Bellmeet Demo</title>
                <meta name="description" content="You can check the BellMeet with the following accesses and the arrival of guest up to a capacity of two people." />
            </Helmet>
            <Nav />
            <div className="demo-wrap">
                <h1>Bellmeet Demo</h1>
                <img src={Supportph} alt="Bellmeet Demo"/>
                <p>
                    Use the link below to see the BellMeet platform environment.
                </p>
                <div className='hero-btns'>
                    <a target="_blank" href="https://online.bellmeet.com/w/1/demo?lang=en">
                        <button>Demo</button>
                    </a>
                </div>
                <p>
                    You can check the BellMeet with the following accesses and the arrival of guest up to a capacity of two people.
                </p>
                <ul>
                    <li>
                        Administrator access:
                        <br/>
                        Username: <span>bellmeet.admin</span>
                        <br/>
                        Password: <span>bellmeet.admin</span>
                    </li>
                </ul>
                <br/>
                <ul>
                    <li>
                        Host access:
                        <br/>
                        Username: <span>bellmeet.host</span>
                        <br/>
                        Password: <span>bellmeet.host</span>
                    </li>
                </ul>
                <br/>
                <ul>
                    <li>
                        Provider access:
                        <br/>
                        Username: <span>bellmeet.provider</span>
                        <br/>
                        Password: <span>bellmeet.provider</span>
                    </li>
                </ul>
                <br/>
                <ul>
                    <li>
                        User access:
                        <br/>
                        Username: <span>bellmeet.user</span>
                        <br/>
                        Password: <span>bellmeet.user</span>
                    </li>
                </ul>
                <br/>
                <p>You can also contact support to request a BellMeet demo with our experts and get exclusive advice.</p>
                <h2>Phone support:
                    +9821-26297306</h2>
                <p>Otherwise, you can start registering for free and have a full service without paying.</p>
                <div className='hero-btns'>
                    <a href='https://panel.bellmeet.com'>
                        <button>Start free</button>
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default DemoEn